import script from "./StatItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatItem.vue?vue&type=script&setup=true&lang=ts"

import "./StatItem.vue?vue&type=style&index=0&id=7729982d&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7729982d"]])

export default __exports__